






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// @ts-nocheck
import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import uniq from "lodash/uniq";

import {
  STORE_KEY,
  store,
  numericId,
  greenClientHasColumnData,
  resolveShipmentForecastMonthPeriod,
} from "./_store";
import moment from "moment";
import ViewLog from "./ViewLog.vue";
import ProductionForecastLog from "./ProductionForecastLog.vue";
import MonthCellDetailLog from "./MonthCellDetailLog.vue";
import ExcelJS from "exceljs";

@Component({
  components: {
    TitleBar,
    ProductionForecastLog,
    MonthCellDetailLog,
  },
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "items",
      "dates",
      "clients",
      "viewMode",
      "transferLoadingByDate",
      "transferLoadingBySourceDate",
      "greenDatesWithData",
      "reportDateFrom",
      "reportDateTo",
    ]),
    ...mapGetters(STORE_KEY, ["total"]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      "setReportOptions",
      "exportData",
      "setFilter",
      "toggleSticker",
      "transferPlanByDate",
    ]),
  },
})
export default class ShipmentForecastByDate extends Vue {
  get isWeekMode() {
    return (
      (this.localFilter && this.localFilter.viewMode === "week") ||
      this.viewMode === "week"
    );
  }

  get isMonthMode() {
    return (
      (this.localFilter && this.localFilter.viewMode === "month") ||
      this.viewMode === "month"
    );
  }

  get titleStack() {
    return ["Прогноз производства"];
  }

  get minDate() {
    return moment().toDate();
  }

  get maxDate() {
    return moment()
      .add(14, "days")
      .toDate();
  }

  get canEditCellActions() {
    return this.viewMode !== "month";
  }

  get canOpenCellDetail() {
    return true;
  }

  get canUseCellActions() {
    return this.canEditCellActions;
  }

  isNegative(value: any) {
    return Number(value) < 0;
  }

  numOrZero(value: any) {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  /** Пустая ячейка при 0 / null; для колонок «Остаток» (col-total) используйте numOrZero + numFormat. */
  formatKgsHideZero(value: any): string {
    const n = Number(value);
    if (!Number.isFinite(n) || n === 0) return "";
    const f = this.$options.filters?.numFormat;
    return f ? f(n, "0,0.00") : String(n);
  }

  /** Одна колонка-дата и это месячный агрегат (не календарные дни). */
  isGreenMonthAggregate(): boolean {
    const d = this.dates || [];
    return d.length === 1 && !!d[0]?.isMonthAggregate;
  }

  /**
   * Объект стикера у зелёного клиента: ключ в state может отличаться (number / string / DocAPI id).
   */
  greenStickerBucket(client: any, stickerId: any): any | null {
    const st = client?.stikers;
    if (!st) return null;
    if (st[stickerId] != null) return st[stickerId];
    const n = numericId(stickerId);
    if (n != null) {
      if (st[n] != null) return st[n];
      if (st[String(n)] != null) return st[String(n)];
    }
    return null;
  }

  greenStickerHasProduct(
    client: any,
    stickerId: any,
    productContainerId: any,
  ): boolean {
    const b = this.greenStickerBucket(client, stickerId);
    if (!b?.products) return false;
    const pid =
      typeof productContainerId === "number"
        ? String(productContainerId)
        : String(productContainerId || "").replace("d:product_containers:", "");
    return !!b.products[pid];
  }

  /** Заголовок колонки даты: для месячного агрегата — полный календарный период. */
  dateColumnHeader(date: any) {
    if (date?.isMonthAggregate && this.reportDateFrom && this.reportDateTo) {
      const a = this.$options.filters.date(this.reportDateFrom, "DD.MM.YYYY");
      const b = this.$options.filters.date(this.reportDateTo, "DD.MM.YYYY");
      return `${a} — ${b}`;
    }
    return this.$options.filters.date(date.date, "dd DD.MM");
  }

  /** Per-zone flags from SET_ITEMS: any product row had non-zero cell (totals in "Итого" can still be zero). */
  zoneVisibilityFlags(dateStr: string, zone: string) {
    const dateEntry = this.dates.find(
      (d: any) => d.type === "date" && d.date === dateStr,
    );
    return dateEntry?.colspan_zones?.[zone];
  }

  showZonePlanCol(dateStr: string, zone: string) {
    const zz = this.zoneVisibilityFlags(dateStr, zone);
    if (zz?.any_plan_or_fact_deal_cell) return true;
    const z = this.total.dates[dateStr]?.[zone];
    const planN = Number(z?.plan) || 0;
    const fdN = Number(z?.fact_deal) || 0;
    return !!(z && (planN > 0 || fdN > 0));
  }

  showZoneTkCol(dateStr: string, zone: string) {
    const zz = this.zoneVisibilityFlags(dateStr, zone);
    if (zz?.any_fact_tk_cell) return true;
    const z = this.total.dates[dateStr]?.[zone];
    return !!(z && Number(z.fact_tk) > 0);
  }

  /** «П»: без «Показать факт» виден только plan-перенос (movement); fact_movement тогда не показываем — колонку не открываем. */
  showZoneMoveCol(dateStr: string, zone: string) {
    const z = this.total.dates[dateStr]?.[zone];
    if (!z) return false;
    const m = Number(z.movement) || 0;
    const fm = Number(z.fact_movement) || 0;
    const showFact = !!this.localFilter.show_fact;
    if (showFact) {
      return Math.abs(m) > 1e-9 || Math.abs(fm) > 1e-9;
    }
    return Math.abs(m) > 1e-9;
  }

  /** Согласовать верхний rowspan с фактическим числом колонок (учёт show_fact для «П»). */
  dateBlockColspan(date: any): number {
    let n = 1;
    const ds = date.date;
    for (const zone of date.zones || []) {
      if (this.showZonePlanCol(ds, zone)) {
        n += 1;
      }
      if (this.showZoneTkCol(ds, zone)) {
        n += 1;
      }
      if (this.showZoneMoveCol(ds, zone)) {
        n += 1;
      }
      const zz = date.colspan_zones?.[zone];
      if (zz && (Number(zz.sell_plan) > 0 || Number(zz.sell_plan_manual) > 0)) {
        n += 1;
      }
    }
    if (this.showGreenClientColumn(date)) {
      n += this.clients.filter((c: any) => this.showGreenClientCell(c, date))
        .length;
    }
    return n;
  }

  /** Подсказка: разбивка плана зелёного клиента по таре в строке стикера. */
  greenStickerBreakdownTooltip(
    client: any,
    stickerId: any,
    dateStr: string,
  ): string {
    const st = this.greenStickerBucket(client, stickerId);
    if (!st?.products) return "";
    const lines: string[] = [];
    const monthAgg =
      this.dates?.length === 1 && this.dates[0]?.isMonthAggregate;
    Object.values(st.products).forEach((p: any) => {
      let kg = 0;
      if (monthAgg) {
        kg = Number(p?.plan || 0);
      } else {
        kg = Number(p?.plan_by_date?.[dateStr] || 0);
      }
      if (kg <= 0) return;
      const label =
        [p.product_name, p.product_container_name].filter(Boolean).join(" ") ||
        `Тара #${p.product_container_id}`;
      lines.push(`${label}: ${Number(kg).toFixed(2)} кг`);
    });
    return lines.length ? lines.join("\n") : "";
  }

  localFilter: any = {
    targetDates: moment()
      .add("day", 1)
      .toDate(),
    show_fact: null,
    viewMode: "week",
    monthFromToday: false,
  };
  opened: any[] = [];

  get defaultSort() {
    return [
      this.$route.query.sortField || "client_name",
      this.$route.query.sortDirection || "asc",
    ];
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction,
      },
    });
  }

  onDetailToggle(row: any, to: string) {
    if (to == "open") {
      this.opened = uniq([...this.opened, row.client_id]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.client_id != row.client_id),
      );
    }
  }

  /**
   * Колонки зелёных клиентов: в месячном режиме — всегда,
   * в week/day — только если для даты есть данные plan_by_date.
   */
  showGreenClientColumn(date: any) {
    if (this.viewMode === "month") return true;
    const dateKey = date?.date;
    if (!dateKey) return false;
    return !!this.greenDatesWithData?.[dateKey];
  }

  /** Колонка зелёного клиента для даты: блок даты открыт и сумма план+факт по дате > 0. */
  showGreenClientCell(client: any, date: any) {
    if (!this.showGreenClientColumn(date)) return false;
    return greenClientHasColumnData(
      client,
      date?.date,
      this.viewMode,
      this.dates,
      date,
    );
  }

  getTransferTargetDate(dateStr: string, direction: number) {
    return moment(dateStr)
      .add(direction, "day")
      .format("YYYY-MM-DD");
  }

  get transferDateSet() {
    return new Set((this.dates || []).map((d: any) => d.date));
  }

  getTransferTooltipDate(dateStr: string, direction: number) {
    const target = this.getTransferTargetDate(dateStr, direction);
    return this.$options.filters.date(target, "dd DD.MM");
  }

  getTransferTooltipLabel(dateStr: string, direction: number) {
    if (!this.canTransferDate(dateStr, direction)) return "Недоступно";
    return this.getTransferTooltipDate(dateStr, direction);
  }

  getTransferAriaLabel(dateStr: string, direction: number) {
    if (!this.canTransferDate(dateStr, direction)) return "Перенос недоступен";
    return `Перенести план на ${this.getTransferTooltipDate(
      dateStr,
      direction,
    )}`;
  }

  hasTransferInFlightFromSource(dateStr: string) {
    if (this.transferLoadingBySourceDate?.[dateStr]) return true;
    const prefix = `${dateStr}->`;
    const m = this.transferLoadingByDate;
    if (!m) return false;
    return Object.keys(m).some((k) => k.startsWith(prefix) && m[k]);
  }

  canTransferDate(dateStr: string, direction: number) {
    if (!this.isWeekMode) return false;
    if (this.hasTransferInFlightFromSource(dateStr)) return false;
    const target = this.getTransferTargetDate(dateStr, direction);
    if (!this.transferDateSet.has(target)) return false;
    const inFlightKey = `${dateStr}->${target}`;
    return !this.transferLoadingByDate?.[inFlightKey];
  }

  isTransferLoadingForDate(dateStr: string) {
    return this.hasTransferInFlightFromSource(dateStr);
  }

  entityNumericId(value: any) {
    return numericId(value);
  }

  zoneGroupIdForDateColumn(date: any, zone: string) {
    if (!date || !date.colspan_zones) return null;
    const cell = date.colspan_zones[zone];
    return numericId(cell && cell.id);
  }

  zoneTransferLoadingKey(
    sourceDate: string,
    targetDate: string,
    zoneGroupId: number,
  ) {
    return `${sourceDate}->${targetDate}:z:${zoneGroupId}`;
  }

  greenTransferLoadingKey(
    sourceDate: string,
    targetDate: string,
    clientId: number,
  ) {
    return `${sourceDate}->${targetDate}:g:${clientId}`;
  }

  canTransferZone(
    dateStr: string,
    zoneGroupId: number | null,
    direction: number,
  ) {
    if (!this.isWeekMode || zoneGroupId == null) return false;
    if (this.hasTransferInFlightFromSource(dateStr)) return false;
    const target = this.getTransferTargetDate(dateStr, direction);
    if (!this.transferDateSet.has(target)) return false;
    const key = this.zoneTransferLoadingKey(dateStr, target, zoneGroupId);
    return !this.transferLoadingByDate?.[key];
  }

  isZoneTransferLoading(
    dateStr: string,
    zoneGroupId: number | null,
    direction: number,
  ) {
    if (zoneGroupId == null) return false;
    const target = this.getTransferTargetDate(dateStr, direction);
    return !!this.transferLoadingByDate?.[
      this.zoneTransferLoadingKey(dateStr, target, zoneGroupId)
    ];
  }

  getZoneTransferTooltipLabel(
    dateStr: string,
    zoneGroupId: number | null,
    direction: number,
  ) {
    if (!this.canTransferZone(dateStr, zoneGroupId, direction))
      return "Недоступно";
    return this.getTransferTooltipDate(dateStr, direction);
  }

  getZoneTransferAriaLabel(
    dateStr: string,
    zoneGroupId: number | null,
    direction: number,
  ) {
    if (!this.canTransferZone(dateStr, zoneGroupId, direction))
      return "Перенос недоступен";
    return `Перенести план зоны на ${this.getTransferTooltipDate(
      dateStr,
      direction,
    )}`;
  }

  canTransferGreenClient(
    dateStr: string,
    clientId: number | null,
    direction: number,
  ) {
    if (!this.isWeekMode || clientId == null) return false;
    if (this.hasTransferInFlightFromSource(dateStr)) return false;
    const target = this.getTransferTargetDate(dateStr, direction);
    if (!this.transferDateSet.has(target)) return false;
    const key = this.greenTransferLoadingKey(dateStr, target, clientId);
    return !this.transferLoadingByDate?.[key];
  }

  isGreenTransferLoading(
    dateStr: string,
    clientId: number | null,
    direction: number,
  ) {
    if (clientId == null) return false;
    const target = this.getTransferTargetDate(dateStr, direction);
    return !!this.transferLoadingByDate?.[
      this.greenTransferLoadingKey(dateStr, target, clientId)
    ];
  }

  getGreenTransferTooltipLabel(
    dateStr: string,
    clientId: number | null,
    direction: number,
  ) {
    if (!this.canTransferGreenClient(dateStr, clientId, direction))
      return "Недоступно";
    return this.getTransferTooltipDate(dateStr, direction);
  }

  getGreenTransferAriaLabel(
    dateStr: string,
    clientId: number | null,
    direction: number,
  ) {
    if (!this.canTransferGreenClient(dateStr, clientId, direction))
      return "Перенос недоступен";
    return `Перенести план клиента на ${this.getTransferTooltipDate(
      dateStr,
      direction,
    )}`;
  }

  onTransferDate(dateStr: string, direction: number) {
    if (!this.canTransferDate(dateStr, direction)) return;
    const targetDate = this.getTransferTargetDate(dateStr, direction);
    const filters = {
      ...this.$route.query,
      targetDates:
        this.$route.query.targetDates ||
        moment(this.localFilter.targetDates).format("YYYY-MM-DD"),
      viewMode: "week",
      show_fact:
        this.$route.query.show_fact !== undefined
          ? this.$route.query.show_fact
          : String(this.localFilter.show_fact),
    };
    this.$store
      .dispatch(`${STORE_KEY}/transferPlanByDate`, {
        sourceDate: dateStr,
        targetDate,
        filters,
      })
      .then(() => {
        this.$buefy.toast.open({
          message: `План перенесен: ${this.$options.filters.date(
            dateStr,
            "DD.MM",
          )} -> ${this.$options.filters.date(targetDate, "DD.MM")}`,
          type: "is-success",
        });
      })
      .catch((err: any) => {
        const msg =
          err?.response?.data?.error || err?.message || "Ошибка переноса плана";
        this.$buefy.toast.open({ message: msg, type: "is-danger" });
      });
  }

  onTransferZone(
    dateStr: string,
    zoneGroupId: number | null,
    direction: number,
  ) {
    if (!this.canTransferZone(dateStr, zoneGroupId, direction)) return;
    const targetDate = this.getTransferTargetDate(dateStr, direction);
    const filters = {
      ...this.$route.query,
      targetDates:
        this.$route.query.targetDates ||
        moment(this.localFilter.targetDates).format("YYYY-MM-DD"),
      viewMode: "week",
      show_fact:
        this.$route.query.show_fact !== undefined
          ? this.$route.query.show_fact
          : String(this.localFilter.show_fact),
    };
    this.$store
      .dispatch(`${STORE_KEY}/transferPlanByDate`, {
        sourceDate: dateStr,
        targetDate,
        filters,
        deliveryZoneGroupId: zoneGroupId,
      })
      .then(() => {
        this.$buefy.toast.open({
          message: `План зоны перенесён: ${this.$options.filters.date(
            dateStr,
            "DD.MM",
          )} -> ${this.$options.filters.date(targetDate, "DD.MM")}`,
          type: "is-success",
        });
      })
      .catch((err: any) => {
        const msg =
          err?.response?.data?.error || err?.message || "Ошибка переноса плана";
        this.$buefy.toast.open({ message: msg, type: "is-danger" });
      });
  }

  onTransferGreenClient(
    dateStr: string,
    clientId: number | null,
    direction: number,
  ) {
    if (!this.canTransferGreenClient(dateStr, clientId, direction)) return;
    const targetDate = this.getTransferTargetDate(dateStr, direction);
    const filters = {
      ...this.$route.query,
      targetDates:
        this.$route.query.targetDates ||
        moment(this.localFilter.targetDates).format("YYYY-MM-DD"),
      viewMode: "week",
      show_fact:
        this.$route.query.show_fact !== undefined
          ? this.$route.query.show_fact
          : String(this.localFilter.show_fact),
    };
    this.$store
      .dispatch(`${STORE_KEY}/transferPlanByDate`, {
        sourceDate: dateStr,
        targetDate,
        filters,
        greenClientId: clientId,
      })
      .then(() => {
        this.$buefy.toast.open({
          message: `План клиента перенесён: ${this.$options.filters.date(
            dateStr,
            "DD.MM",
          )} -> ${this.$options.filters.date(targetDate, "DD.MM")}`,
          type: "is-success",
        });
      })
      .catch((err: any) => {
        const msg =
          err?.response?.data?.error || err?.message || "Ошибка переноса плана";
        this.$buefy.toast.open({ message: msg, type: "is-danger" });
      });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.targetDates =
      this.$route.query && this.$route.query.targetDates
        ? moment(this.$route.query.targetDates).toDate() // @ts-ignore
        : moment()
            .add("day", 1)
            .toDate();
    // @ts-ignore
    this.localFilter.show_fact = this.$route.query.show_fact == "true";
    this.localFilter.viewMode =
      (this.$route.query && (this.$route.query.viewMode as string)) || "week";
    this.localFilter.monthFromToday =
      this.$route.query && this.$route.query.monthFromToday === "true";
  }

  monthDetailPeriodBounds(): { dateFrom: string; dateTo: string } | null {
    if (!this.isMonthMode) return null;
    if (this.reportDateFrom && this.reportDateTo) {
      return { dateFrom: this.reportDateFrom, dateTo: this.reportDateTo };
    }
    const period = resolveShipmentForecastMonthPeriod(
      this.localFilter?.targetDates,
      !!this.localFilter?.monthFromToday,
    );
    return { dateFrom: period.dateFrom, dateTo: period.dateTo };
  }

  /** Период детализации ТК: месяц — весь отчётный период, неделя/день — одна дата ячейки. */
  tkDetailPeriodBounds(
    dateStr?: string | null,
  ): { dateFrom: string; dateTo: string } | null {
    if (this.isMonthMode) {
      return this.monthDetailPeriodBounds();
    }
    if (!dateStr) return null;
    const key =
      typeof dateStr === "string" ? dateStr.slice(0, 10) : null;
    if (!key) return null;
    return { dateFrom: key, dateTo: key };
  }

  formatTkDetailPeriodLabel(bounds: {
    dateFrom: string;
    dateTo: string;
  }): string {
    if (bounds.dateFrom === bounds.dateTo) {
      return this.$options.filters.date(bounds.dateFrom, "DD.MM.YYYY");
    }
    return `${this.$options.filters.date(
      bounds.dateFrom,
      "DD.MM.YYYY",
    )} — ${this.$options.filters.date(bounds.dateTo, "DD.MM.YYYY")}`;
  }

  resolveZoneGroupIdForCell(
    dateCol: any,
    zoneName: string,
    cellZoneId?: any,
  ): number | null {
    const fromCell = this.entityNumericId(cellZoneId);
    if (fromCell != null) return fromCell;
    return this.zoneGroupIdForDateColumn(dateCol, zoneName);
  }

  onTkCellClick(
    value: any,
    zoneName: string,
    item: any,
    dateCol: any,
    cellZoneId?: any,
  ) {
    if (!this.canOpenCellDetail) return;
    this.openTkDetail(
      value,
      zoneName,
      item,
      this.resolveZoneGroupIdForCell(dateCol, zoneName, cellZoneId),
      dateCol?.date,
    );
  }

  zoneCellForTkDetail(
    item: any,
    dateStr: string | null | undefined,
    zoneName: string,
  ): any | null {
    if (!item?.dates || !dateStr) return null;
    const row = item.dates[dateStr];
    if (!row) return null;
    return row[zoneName] ?? null;
  }

  /** Детализация факта ТК: месяц — дневная сводка; неделя/день — сделки как в З/П. */
  openTkDetail(
    value: number,
    zone_name: any,
    item: any,
    zone_id?: number | null,
    dateStr?: string | null,
  ) {
    if (!this.canOpenCellDetail) return;

    const bounds = this.tkDetailPeriodBounds(dateStr);
    const zoneGroupId = zone_id != null ? zone_id : null;
    const productContainerId = this.entityNumericId(item?.product_container_id);

    if (
      !bounds ||
      zoneGroupId == null ||
      productContainerId == null
    ) {
      this.$buefy.toast.open({
        message: "Не удалось подготовить параметры детализации ТК",
        type: "is-danger",
      });
      return;
    }

    if (!this.isMonthMode) {
      const cell = this.zoneCellForTkDetail(item, bounds.dateFrom, zone_name);
      this.$buefy.modal.open({
        component: ViewLog,
        props: {
          value: parseFloat(String(value)),
          stats: cell?.tk_stats?.stats ?? cell?.tk_stats,
          base_weight: cell?.base_weight ?? 0,
          type_id: null,
          zone: `d:delivery_zone_groups:${zoneGroupId}`,
          date: bounds.dateFrom,
          zone_name: zone_name,
          item,
          zone_id: zoneGroupId,
          date_from: bounds.dateFrom,
          date_to: bounds.dateTo,
          cell_date: bounds.dateFrom,
          detailKind: "fact_tk",
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: "document-form short-form",
        parent: this,
      });
      return;
    }

    if (typeof console !== "undefined" && console.debug) {
      console.debug("shipment-forecast-by-date:month-detail:open", {
        detail_type: "fact_tk",
        view_mode: this.viewMode,
        delivery_zone_group_id: zoneGroupId,
        product_container_id: productContainerId,
        date_from: bounds.dateFrom,
        date_to: bounds.dateTo,
        period_mode: this.localFilter?.monthFromToday ? "rolling" : "calendar",
      });
    }

    this.$buefy.modal.open({
      component: MonthCellDetailLog,
      props: {
        request: {
          detail_type: "fact_tk",
          date_from: bounds.dateFrom,
          date_to: bounds.dateTo,
          delivery_zone_group_id: zoneGroupId,
          product_container_id: productContainerId,
        },
        meta: {
          period_label: this.formatTkDetailPeriodLabel(bounds),
          zone_name: zone_name,
          product_label: `${(item && item.product_name) || ""} ${(item &&
            item.product_container_name) ||
            ""}`.trim(),
        },
        cellValue: parseFloat(String(value)),
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this,
    });
  }

  /** Открывает детализацию только для одной ячейки (дата × продукт × стикер). */
  openGreenClientLog(
    client: any,
    stickerId: any,
    productContainerId: any,
    dateStr: string,
    item?: any,
  ) {
    if (!this.canOpenCellDetail) return;
    const productContainerNumericId =
      typeof productContainerId === "number"
        ? productContainerId
        : this.entityNumericId(productContainerId);
    if (productContainerNumericId == null) return;

    const monthBounds = this.monthDetailPeriodBounds();

    const dateFrom =
      monthBounds?.dateFrom ||
      this.reportDateFrom ||
      (this.dates && this.dates.length
        ? this.dates[0].date
        : moment().format("YYYY-MM-DD"));
    const dateTo =
      monthBounds?.dateTo ||
      this.reportDateTo ||
      (this.dates && this.dates.length
        ? this.dates[this.dates.length - 1].date
        : moment().format("YYYY-MM-DD"));

    const cellPlanIds = this.getGreenCellPlanIds(
      client,
      stickerId,
      productContainerNumericId,
      dateStr,
    );

    if (this.isMonthMode) {
      const monthPlanIds = this.getGreenCellPlanIdsForRange(
        client,
        stickerId,
        productContainerNumericId,
        dateFrom,
        dateTo,
      );

      if (typeof console !== "undefined" && console.debug) {
        console.debug("shipment-forecast-by-date:month-detail:open", {
          detail_type: "green",
          client_id: this.entityNumericId(client.id),
          delivery_zone_group_id: this.entityNumericId(
            client.delivery_zone_group_id,
          ),
          product_container_id: productContainerNumericId,
          date_from: dateFrom,
          date_to: dateTo,
          plan_ids_count: monthPlanIds.length,
          period_mode: this.localFilter?.monthFromToday ? "rolling" : "calendar",
        });
      }

      this.$buefy.modal.open({
        component: MonthCellDetailLog,
        props: {
          request: {
            detail_type: "green",
            date_from: dateFrom,
            date_to: dateTo,
            plan_ids: monthPlanIds,
            client_id: this.entityNumericId(client.id),
            delivery_zone_group_id: this.entityNumericId(
              client.delivery_zone_group_id,
            ),
            product_container_id: productContainerNumericId,
          },
          meta: {
            period_label: `${this.$options.filters.date(
              dateFrom,
              "DD.MM.YYYY",
            )} — ${this.$options.filters.date(dateTo, "DD.MM.YYYY")}`,
            client_name: client.name,
            product_label: `${(item && item.product_name) || ""} ${(item &&
              item.product_container_name) ||
              ""}`.trim(),
          },
          cellValue: this.getGreenCellPlanValue(
            client,
            stickerId,
            productContainerNumericId,
            dateStr,
          ),
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: "document-form short-form",
        parent: this,
      });
      return;
    }

    if (!cellPlanIds || cellPlanIds.length === 0) return;

    this.$buefy.modal.open({
      component: ProductionForecastLog,
      props: {
        row: {
          plan_ids: cellPlanIds,
          date_from: dateFrom,
          date_to: dateTo,
          client_name: client.name,
          delivery_zone_group_name: "—",
          product_name: (item && item.product_name) ?? "",
          product_container_name: (item && item.product_container_name) ?? "",
        },
      },
      events: {
        close: () => {
          /* modal closed */
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this,
    });
  }

  /** plan_ids только для ячейки (дата × продукт × стикер). */
  getGreenCellPlanIds(
    client: any,
    stickerId: any,
    productContainerId: any,
    date: string,
  ): number[] | null {
    const bucket = this.greenStickerBucket(client, stickerId);
    if (!bucket?.products) return null;
    const pid =
      typeof productContainerId === "number"
        ? String(productContainerId)
        : (productContainerId || "").replace("d:product_containers:", "");
    const byDate = bucket.products[pid]?.plan_ids_for_date;
    if (!byDate || !date) return null;
    const ids = byDate[date];
    return Array.isArray(ids) && ids.length > 0 ? ids : null;
  }

  getGreenCellPlanIdsForRange(
    client: any,
    stickerId: any,
    productContainerId: any,
    dateFrom: string,
    dateTo: string,
  ): number[] {
    const bucket = this.greenStickerBucket(client, stickerId);
    if (!bucket?.products) return [];
    const pid =
      typeof productContainerId === "number"
        ? String(productContainerId)
        : (productContainerId || "").replace("d:product_containers:", "");
    const byDate = bucket.products[pid]?.plan_ids_for_date;
    if (!byDate) return [];

    const from = moment(dateFrom, "YYYY-MM-DD");
    const to = moment(dateTo, "YYYY-MM-DD");
    const hasRange = from.isValid() && to.isValid();
    const idsSet = new Set<number>();

    Object.keys(byDate).forEach((dateKey) => {
      if (hasRange) {
        const day = moment(dateKey, "YYYY-MM-DD");
        if (
          !day.isValid() ||
          day.isBefore(from, "day") ||
          day.isAfter(to, "day")
        )
          return;
      }
      const ids = byDate[dateKey];
      if (!Array.isArray(ids)) return;
      ids.forEach((id: any) => {
        const parsed = this.entityNumericId(id);
        if (parsed != null) idsSet.add(parsed);
      });
    });

    return Array.from(idsSet);
  }

  /**
   * Значение плана для ячейки зелёного клиента по календарной дате колонки.
   * Нельзя использовать prod.plan (сумма по всем датам) как fallback при нескольких
   * колонках дат: иначе в каждой колонке недели показывается один и тот же итог, а при
   * совпадении итогов у клиентов — «все зелёные одинаковые». Fallback на prod.plan только
   * для месячного агрегата (ровно одна дата в отчёте).
   */
  getGreenCellPlanValue(
    client: any,
    stickerId: any,
    productContainerId: any,
    date: string,
  ): number {
    const pid =
      typeof productContainerId === "number"
        ? String(productContainerId)
        : (productContainerId || "").replace("d:product_containers:", "");
    const bucket = this.greenStickerBucket(client, stickerId);
    const prod = bucket?.products?.[pid];
    if (!prod) return 0;
    if (this.isGreenMonthAggregate()) return Number(prod.plan ?? 0);
    const byDate = prod.plan_by_date;
    if (!date) return Number(prod.plan ?? 0);
    const v = byDate ? byDate[date] : undefined;
    if (v != null && v !== "") return Number(v);
    const dates = this.dates || [];
    const singleMonthAggregate =
      dates.length === 1 && !!dates[0]?.isMonthAggregate;
    if (singleMonthAggregate) return Number(prod.plan ?? 0);
    return 0;
  }

  getGreenCellFactValue(
    client: any,
    stickerId: any,
    productContainerId: any,
    date: string,
  ): number {
    const pid =
      typeof productContainerId === "number"
        ? String(productContainerId)
        : (productContainerId || "").replace("d:product_containers:", "");
    const bucket = this.greenStickerBucket(client, stickerId);
    const prod = bucket?.products?.[pid];
    if (!prod) return 0;
    if (this.isGreenMonthAggregate()) return Number(prod.fact ?? 0);
    if (!date) return Number(prod.fact ?? 0);
    const byDate = prod.fact_by_date || {};
    const v = byDate[date];
    if (v != null && v !== "") return Number(v);
    const dates = this.dates || [];
    const singleMonthAggregate =
      dates.length === 1 && !!dates[0]?.isMonthAggregate;
    if (singleMonthAggregate) return Number(prod.fact ?? 0);
    return 0;
  }

  getGreenStickerPlanValue(client: any, stickerId: any, date: string): number {
    const bucket = this.greenStickerBucket(client, stickerId);
    if (!bucket) return 0;
    if (this.isGreenMonthAggregate()) {
      let t = Number(bucket.plan || 0);
      if (t === 0 && bucket.products) {
        t = Object.values(bucket.products).reduce(
          (s: number, p: any) => s + Number(p?.plan || 0),
          0,
        );
      }
      return t;
    }
    let total = 0;
    Object.values(bucket.products || {}).forEach((prod: any) => {
      total += Number(prod?.plan_by_date?.[date] || 0);
    });
    return total;
  }

  getGreenStickerFactValue(client: any, stickerId: any, date: string): number {
    const bucket = this.greenStickerBucket(client, stickerId);
    if (!bucket) return 0;
    if (this.isGreenMonthAggregate()) {
      let t = Number(bucket.fact || 0);
      if (t === 0 && bucket.products) {
        t = Object.values(bucket.products).reduce(
          (s: number, p: any) => s + Number(p?.fact || 0),
          0,
        );
      }
      return t;
    }
    let total = 0;
    Object.values(bucket.products || {}).forEach((prod: any) => {
      total += Number(prod?.fact_by_date?.[date] || 0);
    });
    return total;
  }

  getGreenClientPlanValue(client: any, date: string): number {
    if (this.isGreenMonthAggregate()) {
      return Number(client?.plan || 0);
    }
    const stikers = client?.stikers || {};
    let total = 0;
    Object.values(stikers).forEach((st: any) => {
      Object.values(st?.products || {}).forEach((prod: any) => {
        total += Number(prod?.plan_by_date?.[date] || 0);
      });
    });
    return total;
  }

  getGreenClientFactValue(client: any, date: string): number {
    if (this.isGreenMonthAggregate()) {
      return Number(client?.fact || 0);
    }
    const stikers = client?.stikers || {};
    let total = 0;
    Object.values(stikers).forEach((st: any) => {
      Object.values(st?.products || {}).forEach((prod: any) => {
        total += Number(prod?.fact_by_date?.[date] || 0);
      });
    });
    return total;
  }

  /** Вес одной тары для продукта (из зон в дате; для зелёного клиента зона может быть не заполнена — ищем по любой зоне). */
  getGreenCellBaseWeight(item: any, date: any): number {
    const byDate = item?.dates?.[date?.date];
    if (!byDate || typeof byDate !== "object") return 0;
    const zonesToTry = date?.zones?.length ? date.zones : Object.keys(byDate);
    for (const zoneName of zonesToTry) {
      const cell = byDate[zoneName];
      const w = Number(cell?.base_weight ?? 0);
      if (w > 0) return w;
    }
    return 0;
  }

  /** Вес тары для зоны: из ячейки или соседних зон даты (пустой план после паддинга даёт base_weight 0). */
  resolveZonePlanBaseWeight(item: any, dateCol: any, zoneKey: string): number {
    const byDate = item?.dates?.[dateCol?.date];
    const cell = byDate?.[zoneKey];
    const w = Number(cell?.base_weight ?? 0);
    if (w > 0) return w;
    return this.getGreenCellBaseWeight(item, dateCol);
  }

  /** green-client-planning-manual-edit: диалог ввода значения плана для зелёного клиента (одна ячейка), кг. */
  promptGreenClientManualEdit(
    client: any,
    stickerId: any,
    productContainerId: any,
    date: string,
    currentPlan: number | null | undefined,
    baseWeight: number,
  ) {
    if (!this.canEditCellActions) return;
    const value =
      currentPlan != null && currentPlan !== undefined
        ? String(currentPlan)
        : "";
    this.$buefy.dialog.prompt({
      message: "Введите значение плана",
      inputAttrs: {
        type: "number",
        step: "0.01",
        value,
      },
      trapFocus: true,
      onConfirm: (manualQuantity: string) => {
        this.saveGreenClientManual(
          client,
          stickerId,
          productContainerId,
          date,
          manualQuantity,
          baseWeight,
        );
      },
    });
  }

  /** Ручное редактирование плана по группе зон (одна ячейка). Пользователь вводит вес в кг, перед API переводим в тары (ceil(кг / base_weight)). */
  promptZonePlanManualEdit(
    zoneId: number,
    dateStr: string,
    productContainerId: any,
    typeId: number,
    currentPlanContainers: number | null | undefined,
    stickerId: any,
    zoneKey: string,
    item: any,
    dateCol: any,
  ) {
    if (!this.canEditCellActions) return;
    const pid =
      typeof productContainerId === "number"
        ? productContainerId
        : parseInt(
            String(productContainerId).replace(/^d:product_containers:/, ""),
            10,
          ) || 0;
    const value =
      currentPlanContainers != null ? String(currentPlanContainers) : "";
    this.$buefy.dialog.prompt({
      message: "Введите значение плана, кг",
      inputAttrs: { type: "number", step: "0.01", value },
      trapFocus: true,
      onConfirm: (manualQuantityKg: string) => {
        this.saveZonePlanManual(
          zoneId,
          dateStr,
          pid,
          typeId,
          manualQuantityKg,
          stickerId,
          zoneKey,
          item,
          dateCol,
        );
      },
    });
  }

  /** Переводит кг в тары (целое число, округление вверх). */
  kgToContainers(kg: number, baseWeight: number): number {
    if (!baseWeight || baseWeight <= 0) return 0;
    return Math.ceil(kg / baseWeight);
  }

  saveZonePlanManual(
    zoneId: number,
    dateStr: string,
    productContainerId: number,
    typeId: number,
    manualQuantityKg: string,
    stickerId: any,
    zoneKey: string,
    item: any,
    dateCol: any,
  ) {
    const baseWeight = this.resolveZonePlanBaseWeight(item, dateCol, zoneKey);
    const kg = parseFloat(String(manualQuantityKg).replace(",", ".")) || 0;
    const containers = this.kgToContainers(kg, baseWeight);
    if (kg !== 0 && containers === 0) {
      this.$buefy.toast.open({
        message:
          "Не задан вес тары для этого продукта — нельзя перевести кг в количество тар",
        type: "is-danger",
      });
      return;
    }
    const filters = {
      ...this.$route.query,
      targetDates:
        this.$route.query.targetDates ||
        moment(this.localFilter.targetDates).format("YYYY-MM-DD"),
      viewMode:
        this.$route.query.viewMode || this.localFilter.viewMode || "week",
    };
    this.$store
      .dispatch(`${STORE_KEY}/saveZonePlanManualQuantity`, {
        deliveryZoneGroupId: zoneId,
        date: dateStr,
        productContainerId,
        typeId,
        manualQuantity: containers,
        stickerId,
        baseWeight,
        zoneKey,
        filters,
      })
      .then(() => {
        this.$buefy.toast.open({ message: "Сохранено", type: "is-success" });
      })
      .catch((err: any) => {
        const msg =
          err?.response?.data?.error || err?.message || "Ошибка сохранения";
        this.$buefy.toast.open({ message: msg, type: "is-danger" });
      });
  }

  /** green-client-planning-manual-edit: кг → целые тары → кг, обновление одной ячейки без перезагрузки. */
  saveGreenClientManual(
    client: any,
    stickerId: any,
    productContainerId: any,
    date: string,
    manualQuantityKg: string,
    baseWeight: number,
  ) {
    const planIds =
      this.getGreenCellPlanIds(client, stickerId, productContainerId, date) ||
      [];
    const productId =
      typeof productContainerId === "number"
        ? String(productContainerId)
        : (productContainerId || "").replace("d:product_containers:", "");
    const filters = {
      ...this.$route.query,
      targetDates:
        this.$route.query.targetDates ||
        moment(this.localFilter.targetDates).format("YYYY-MM-DD"),
      viewMode:
        this.$route.query.viewMode || this.localFilter.viewMode || "week",
    };
    this.$store
      .dispatch(`${STORE_KEY}/saveManualQuantity`, {
        planIds,
        targets:
          planIds.length > 0
            ? []
            : [
                {
                  client_id: Number(client.id),
                  delivery_zone_group_id: Number(
                    client.delivery_zone_group_id || 0,
                  ),
                  product_container_id: Number(productId),
                  sticker_id: Number(stickerId),
                  date,
                },
              ],
        manualQuantityKg,
        baseWeight,
        clientId: client.id,
        stickerId,
        productId,
        dateStr: date,
        filters,
      })
      .then(() => {
        this.$buefy.toast.open({
          message: "Сохранено",
          type: "is-success",
        });
        if (planIds.length === 0) this.loadData();
      })
      .catch((err: any) => {
        const msg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.error) ||
          (err && err.message) ||
          "Ошибка сохранения";
        this.$buefy.toast.open({ message: msg, type: "is-danger" });
      });
  }

  openLog(
    value: number,
    stats: any,
    base_weight: number,
    type_id: any,
    zone: any,
    date: any,
    zone_name: any,
    item: any,
    zone_id?: number,
    date_from?: string,
    date_to?: string,
  ) {
    if (!this.canOpenCellDetail) return;

    if (this.isMonthMode) {
      const zoneGroupId = this.entityNumericId(zone_id || zone);
      const productContainerId = this.entityNumericId(
        item?.product_container_id,
      );
      const typeId = this.entityNumericId(type_id);
      const monthBounds = this.monthDetailPeriodBounds();
      const reportDateFrom =
        monthBounds?.dateFrom ||
        this.reportDateFrom ||
        date_from ||
        (typeof date === "string" ? date : null);
      const dateTo =
        monthBounds?.dateTo ||
        this.reportDateTo ||
        date_to ||
        (typeof date === "string" ? date : null);

      if (
        zoneGroupId == null ||
        productContainerId == null ||
        typeId == null ||
        !reportDateFrom ||
        !dateTo
      ) {
        this.$buefy.toast.open({
          message: "Не удалось подготовить параметры детализации",
          type: "is-danger",
        });
        return;
      }

      if (typeof console !== "undefined" && console.debug) {
        console.debug("shipment-forecast-by-date:month-detail:open", {
          detail_type: "zone",
          delivery_zone_group_id: zoneGroupId,
          product_container_id: productContainerId,
          type_id: typeId,
          date_from: reportDateFrom,
          date_to: dateTo,
          period_mode: this.localFilter?.monthFromToday ? "rolling" : "calendar",
        });
      }

      this.$buefy.modal.open({
        component: MonthCellDetailLog,
        props: {
          request: {
            detail_type: "zone",
            date_from: reportDateFrom,
            date_to: dateTo,
            delivery_zone_group_id: zoneGroupId,
            product_container_id: productContainerId,
            type_id: typeId,
          },
          meta: {
            period_label: `${this.$options.filters.date(
              reportDateFrom,
              "DD.MM.YYYY",
            )} — ${this.$options.filters.date(dateTo, "DD.MM.YYYY")}`,
            zone_name: zone_name,
            product_label: `${(item && item.product_name) || ""} ${(item &&
              item.product_container_name) ||
              ""}`.trim(),
          },
          cellValue: parseFloat(value),
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: "document-form short-form",
        parent: this,
      });
      return;
    }

    this.$buefy.modal.open({
      component: ViewLog,
      props: {
        value: parseFloat(value),
        stats,
        base_weight,
        type_id,
        zone,
        date,
        zone_name,
        item,
        zone_id: zone_id ?? null,
        date_from: date_from ?? null,
        date_to: date_to ?? null,
        cell_date:
          typeof date === "string"
            ? date
            : (date && (date as any).date) ?? null,
      },
      events: {
        "form-close": () => {
          this.loadData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this,
    });
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      if (key === "targetDates") {
        ac[key] = moment(this.localFilter[key]).format("YYYY-MM-DD");
      } else if (key === "monthFromToday") {
        ac[key] = this.localFilter.monthFromToday ? "true" : "false";
      } else {
        ac[key] = this.localFilter[key];
      }
      return ac;
    }, {});

    this.$router.replace({
      query,
    });
    this.$store.dispatch(`${STORE_KEY}/loadData`, query);
  }

  tableToExcel(no_products: boolean = false) {
    this.$store
      .dispatch(`${STORE_KEY}/exportData`, {
        ...this.localFilter,
        no_products,
        showColumns: this.showColumns,
      })
      .then((workbook: any[]) => {
        workbook.xlsx
          .writeBuffer()
          .then(function(xls64: any) {
            const a = document.createElement("a");
            const data = new Blob([xls64], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = URL.createObjectURL(data);
            a.href = url;
            a.download = "export.xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          })
          .catch(function(_error: any) {
            // export error ignored
          });
      });
  }

  // ---------------------------------------------------------------------------

  // Загрузка данных запускается только по кнопке "Фильтр".
}
